export default __webpack_public_path__ + "static/media/796.423cc600.png";